<div class="flex flex-wrap items-center justify-between gap-2">
  <small class="text-xs text-text-600">
    Mostrando itens
    <b class="font-bold text-text-900">
      {{ startInterval() }}-{{ endInterval() }}
    </b>
    de
    <b class="font-bold text-text-900">
      {{ totalRecords() }}
    </b>
  </small>

  <p-paginator
    #paginator
    (onPageChange)="onPageChange($event)"
    [first]="currentFirst()"
    [rows]="rows()"
    [totalRecords]="totalRecords()"
    [showFirstLastIcon]="false"
    class="w-full bg-transparent md:w-auto"
  ></p-paginator>
</div>
